import React, { FC } from 'react';
import cnBind from 'classnames/bind';
import { useStoreon } from 'storeon/react';
import { Events, State } from '@/interfaces';
import styles from '../../styles/index.module.scss';

interface IServicesComponent {
  activeSideBarItem: number;
  clickItem: (service: Record<string, any>) => void;
  activeItem: Record<string, any> | null;
  setCount: (e: number) => void;
  count: number
}

const ServicesComponent: FC<IServicesComponent> = ({  clickItem, activeItem }) => {
  const { services } = useStoreon<State, Events>('services');
  const cn = cnBind.bind(styles);

  return (
    <div className={cn({
      list: services.length !== 0,
      'list--missing': services.length === 0
    })}>
      {services.length === 0 ?
        <p>
          Услуги отсутсвуют...
        </p>
        :
        <>
          {services.map((service) => {
            return (
              <div
                key={service.id}
                onClick={() => clickItem(service)}
                role='button'
                tabIndex={0}
                className={cn({
                  'list__item': true,
                  'list__item--active': activeItem?.id === service.id
                })}
              >
                <>
                  <p className={styles['list__item--title']}>{service.title}</p>
                </>
                <div className={styles['list__item_info']}>
                  <span className={styles['list__item_info--price']}>{service.default_price.toLocaleString()}</span>
                  {
                  /* 
                    * TODO: Добавить возможность выбора количества услуги
                   */
                  /* {(activeItem?.id === service.id) &&
                    <div className={styles['count']}>
                      <button type='button' className={styles['count--btn']} disabled={count === 1} onClick={() => setCount(count - 1)}>
                        <GxIcon src={MinusIcon} className={styles['count--icon']} />
                      </button>
                      <span className={styles['count--text']}>{count}</span>
                      <button type='button' className={styles['count--btn']} onClick={() => setCount(count + 1)}>
                        <GxIcon src={PlusIcon} className={styles['count--icon']} />
                      </button>
                    </div>
                  } */}
                </div>
              </div>
            )
          })}
        </>
      }
    </div>
  );
};

export default ServicesComponent;